<template>
    <div class="error error__404">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-6">
                    <component-box
                        :title="'404 - Page not found'"
                        :content="'Sorry, but we’re unable to find anything on this URL. Please check your URL and try again.'"
                        :button-active="true"
                        :button-text="'Go back'"
                        @emit-click="redirectBack"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentBox from '@/components/default/shared/ComponentBox'
export default {
  name: 'error-404',
  components: { ComponentBox },
  methods: {
    redirectBack () {
      this.$router.push({ name: 'default' })
    }
  }
}
</script>
